/**
 *
 * Asynchronously loads the component for PostToIndeed
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
